// Use throughout your app instead of plain `useDispatch` and `useSelector`
import { useDispatch, useSelector, useStore } from 'react-redux';
import type { TypedUseSelectorHook } from 'react-redux';
import type { Store } from 'redux';
import type { RootState, AppDispatch } from '.';
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export const useAppStore: () => Store<RootState> = useStore;
